var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85711 0.856689H21.4285C22.3753 0.856689 23.1428 1.6242 23.1428 2.57098V17.1424C23.1428 18.0892 22.3753 18.8567 21.4285 18.8567H6.85711C5.91033 18.8567 5.14282 18.0892 5.14282 17.1424V2.57098C5.14282 1.6242 5.91033 0.856689 6.85711 0.856689Z",
    stroke: "#1D1D1D",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.45577 4.40088V19.8295C2.45577 20.2841 2.63639 20.7201 2.95788 21.0416C3.27937 21.3631 3.7154 21.5437 4.17006 21.5437H19.5986",
    stroke: "#1D1D1D",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.342 13.0964V6.61635C11.3407 6.50571 11.3692 6.39676 11.4245 6.3009C11.4797 6.20503 11.5597 6.12579 11.6561 6.07146C11.7525 6.01713 11.8617 5.98972 11.9724 5.99208C12.083 5.99445 12.1909 6.02652 12.2849 6.08492L17.8906 9.32492C17.983 9.37948 18.0596 9.45719 18.1128 9.55039C18.166 9.64358 18.194 9.74904 18.194 9.85635C18.194 9.96366 18.166 10.0691 18.1128 10.1623C18.0596 10.2555 17.983 10.3332 17.8906 10.3878L12.2849 13.7135C12.1846 13.7779 12.0679 13.8119 11.9487 13.8114C11.8296 13.8109 11.7131 13.7759 11.6134 13.7106C11.5137 13.6453 11.435 13.5526 11.3869 13.4436C11.3387 13.3346 11.3231 13.214 11.342 13.0964Z",
    stroke: "#1D1D1D",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.80d80005f222ccb1547d98059361b076.svg";
export { ForwardRef as ReactComponent };